<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
>
</bwh-lib-step-control-bar>
<div class="cv-skills text-center step-wrapper" *ngIf="dataLoaded && skills.length">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.cv_skills_title' | translate }}</h1>
    <p class="main-description mb-5">{{ 'global.cv_skills_description' | translate }}</p>
  </div>
  <div class="scrollable-content">
    <div class="skills-chips">
      <div class="skill-chip" *ngFor="let skill of skills; let i = index">
        <span class="skill-name">{{ skill.skill_name || skill.skill_mapping_name }}</span>
        <button type="button" class="remove-btn" (click)="removeSkill(i)" [attr.aria-label]="'global.remove' | translate">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <ul class="next-button-container">
      <li *ngIf="prevBut === true">
        <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
          {{ 'global.previous' | translate }}
        </button>
      </li>
      <li>
        <button class="btn w-md h-lg secondary" type="button" (click)="nextStep()">
          {{ 'global.next_button' | translate }}
        </button>
      </li>
    </ul>
  </div>
</div>
